import {
  HistoryOutlined,
  LockOutlined,
  PoweroffOutlined,
  UserOutlined,
} from '@ant-design/icons';
import { Avatar, Dropdown, Menu, Typography, message } from 'antd';
import { ChangePasswordForm } from 'components/ChangePasswordForm';
import { Portal } from 'components/Portal';
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { TribesService } from 'services/TribesService';
import {
  regenerateTokenNewTribe,
  sessionClose,
  setSelectedTribe,
} from 'store/reducers/authReducer';
import { getInitials, usernameToColor } from 'utils/avatar';
import { useNavigate } from 'react-router-dom';
import { AvatarWrapper } from './style';

function UserAvatar({
  username,
  role,
  tribeName,
  tribeRole,
  isSuperUser,
  password_old,
}) {
  const [changePas, setChangePas] = useState(false);
  const [tribes, setTribes] = useState([]);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const userTribes = tribeRole?.map((item) => {
    const tribe = tribes.find((i) => i.id === item.tribe_id);
    return { ...tribe, ...item };
  });

  const regenerateToken = async (tribeId) => {
    try {
      const payload = {
        refresh_token: localStorage.getItem('refresh_token'),
        tribe_id: tribeId,
      };
      const token = await TribesService.regenerateTokenWithTribe(payload);
      localStorage.setItem('token', token.access_token);

      return token;
    } catch (error) {
      message.error('Ошибка при обновлении токена:', error);
    }
  };

  async function handleClick(id) {
    try {
      const token = await regenerateToken(id);
      dispatch(regenerateTokenNewTribe(token.access_token));
      dispatch(setSelectedTribe(id));
      // eslint-disable-next-line no-restricted-globals
      location.reload();
    } catch (error) {
      message.error('Ошибка при обработке клика:', error);
    }
  }

  useEffect(() => {
    fetchTribes();
  }, []);

  const fetchTribes = async () => {
    try {
      const { items } = await TribesService.getTribes(1, 10);
      setTribes(items);
    } catch (err) {
      message.error('Не удалось загрузить трайбы');
    }
  };

  const handleLogout = () => {
    dispatch(sessionClose());
  };

  const handlePasswordChangeSuccess = () => {
    setChangePas(false);
    message.success('Пароль успешно изменён');
  };

  // TODO: Need to fix api endpoint for changing password.
  const menu = (
    <Menu style={{ borderRadius: '4px' }} triggerSubMenuAction="click">
      {!isSuperUser && (
        <Menu.SubMenu
          expandIcon={() => null}
          icon={<UserOutlined />}
          title="Роль в трайбе"
          key="TribeSubMenu"
        >
          {userTribes.map(({ title, role_name, id }) => (
            <Menu.Item
              key={id}
              onClick={() => {
                handleClick(id);
              }}
            >
              {`${role_name} в ${title}`}
            </Menu.Item>
          ))}
        </Menu.SubMenu>
      )}

      <Menu.Divider />

      <Menu.Item
        key="session_history"
        icon={<HistoryOutlined />}
        onClick={() => navigate('/session-history')}
      >
        История сессий
      </Menu.Item>

      <Menu.Divider />

      <Menu.Item
        key="1"
        icon={<LockOutlined />}
        onClick={() => setChangePas(true)}
        disabled={isSuperUser}
      >
        Сменить пароль
      </Menu.Item>

      <Menu.Divider />

      <Menu.Item
        key="2"
        icon={<PoweroffOutlined />}
        danger
        onClick={handleLogout}
      >
        Выйти из системы
      </Menu.Item>
    </Menu>
  );

  return (
    <>
      <Dropdown overlay={menu} trigger={['click']}>
        <AvatarWrapper>
          <Avatar
            style={{
              backgroundColor: usernameToColor(username),
              verticalAlign: 'middle',
            }}
            size="default"
          >
            {getInitials(username)}
          </Avatar>

          <div className="user-info">
            <span className="user-name">{username}</span>
            <Typography.Text type="secondary" style={{ fontSize: '13px' }}>
              {isSuperUser ? `${role}` : `${role} в ${tribeName}`}
            </Typography.Text>
            {!isSuperUser && (
              <Typography.Text
                type={30 - password_old >= 15 ? 'secondary' : 'danger'}
                style={{ fontSize: '13px' }}
              >
                До смены пароля {30 - password_old} дней
              </Typography.Text>
            )}
          </div>
        </AvatarWrapper>
      </Dropdown>

      <Portal targetId="root">
        <ChangePasswordForm
          isActive={changePas}
          onClose={() => setChangePas(false)}
          onSuccess={handlePasswordChangeSuccess}
        />
      </Portal>
    </>
  );
}

export { UserAvatar };
